import React from 'react'

const SolutionCard = ({ img, name, url }) => {
  const handleCardClick = () => {
    window.location.href = url;
  };

  return (
    <div
      onClick={handleCardClick}
      className='relative group cursor-pointer max-sm:w-[100%] max-sm:flex-[1_0_75%] w-full flex-[0_1_23%] h-64 md:h-72 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-500'
    >
      <img
        src={img}
        alt={name}
        className='absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110'
      />

      <div
        className='absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out'
        style={{
          background:
            'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.25) 55%, rgba(0,0,0,0) 100%)',
        }}
      />

      <div
        className='absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-500'
        style={{ transitionTimingFunction: 'cubic-bezier(0.22,1,0.36,1)' }}
      >
        <div className='w-10 h-0.5 bg-white bg-opacity-80 rounded-full mb-3' />
        <p className='text-white font-semibold text-lg md:text-xl leading-snug'>
          {name}
        </p>
      </div>
    </div>
  );
}

export default SolutionCard;